function getTransitionEndEventName() {
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/transitionend_event
  const transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
  };
  let bodyStyle = document.body.style;
  for (let transition in transitions) {
    if (bodyStyle[transition] !== undefined) {
      return transitions[transition];
    }
  }
}

export default getTransitionEndEventName;
